import styled, { css } from 'vue-styled-components';
import COLORS from '@design/colors.js';
import { darken } from 'polished';

import {
    FLEX_CENTER,
    square,
    applyHoverAndPress,
} from '@/styles/common.styled';

import {
    FLEX_VERTICAL_CENTER_DIV,
    FLEX_CENTER_DIV,
    FLEX_DIV,
} from '@/styles/common.styled.component';

export const Wrapper = styled(FLEX_CENTER_DIV)`
    width: 100%;
    min-height: 65px;
    border-radius: 5px;
    border: solid 1px #d4d8db;
    background-color: white;
    box-shadow: none;
    position: relative;
    max-width: 482px;
    @media screen and (max-width: 800px) {
        max-width: initial;
    }
`;

export const TopContainer = styled(FLEX_VERTICAL_CENTER_DIV)`
    justify-content: space-between;
    width: 100%;
    padding: 16px;
    flex-wrap: wrap;
`;

export const FlexContainer = styled(FLEX_CENTER_DIV)`
    justify-content: flex-start;
    max-width: calc(100% - 70px);
`;

export const AccountIcon = styled('span', { color: String })`
    ${FLEX_CENTER}
    ${square(24)}
    border-radius: 50%;
    font-size: 14px;
    font-weight: 500;
    color: white;
    background-color: ${R.propOr('#0054C6', 'color')};
`;

export const AccountText = styled.span`
    font-size: 15px;
    font-weight: 600;
    color: #4d5058;
    margin-left: 5px;
    margin-right: 10px;
`;

export const DropdownWrapper = styled.div`
    width: calc(100% - 126px);

    > div {
        height: 44px;
        padding: 0px;
        border: solid 1px ${COLORS['gray-25']};
    }
    svg {
        ${square(20)}
    }
    .dropdown-trigger > div {
        padding-left: 16px;
    }
`;

export const SetDefaultBtn = styled.button`
    ${FLEX_CENTER}
    height: 25px;
    border-radius: 3px;
    border: solid 1px #dddddd;
    background-color: #f2f3f5;
    font-size: 11px;
    color: #666666;
    flex-shrink: 0;
    &:hover {
        background-color: #eee;
    }
`;

export const BottomContainer = styled.div`
    position: absolute;
    top: 70px;
    left: 0;
    right: 0;
    z-index: 1;
    border-radius: 5px;
    box-shadow: 0.7px 0.7px 10px 0 rgba(0, 0, 0, 0.15);
    background-color: white;
    animation-duration: 0.3s;
`;

export const AccountElem = FLEX_CENTER_DIV;

export const Badge = styled('span', { color: String })`
    width: 15px;
    height: 15px;
    border-radius: 50%;
    flex-shrink: 0;
    background-color: ${R.propOr('#0054C6', 'color')};
`;

export const ElemText = styled.span`
    margin-left: 8px;
    font-size: 14px;
    color: ${COLORS['gray-60']};
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const SettingIcon = styled.i`
    color: #666666;
    cursor: pointer;

    &:last-child {
        margin-left: 10px;
    }

    &:hover {
        color: #999;
    }
`;

export const TeamsContainer = styled.div`
    max-height: 212px;
    margin-top: 20px;
    border-top: 1px solid ${COLORS['gray-15']};
    overflow-y: auto;
`;

export const TeamsLeft = styled(FLEX_VERTICAL_CENTER_DIV)`
    cursor: pointer;
`;

export const TeamText = styled.div`
    font-size: 14px;
    color: ${COLORS['gray-100']};
    margin-left: 12px;
    display: flex;
    align-items: center;
    svg {
        margin-left: 4px;
    }
`;

export const InviteText = styled.div`
    font-size: 13px;
    font-weight: 500;
    ${applyHoverAndPress(COLORS['blue-60'])};
    margin-left: 4px;
    cursor: pointer;
`;

export const InviteWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    margin-left: auto;

    svg {
        fill: ${COLORS['blue-60']};
        ${square(11)};
    }

    &:hover {
        .invite-text {
            color: ${darken(0.1, COLORS['blue-60'])};
        }

        svg {
            fill: ${darken(0.1, COLORS['blue-60'])};
        }
    }

    &:active {
        .invite-text {
            color: ${darken(0.2, COLORS['blue-60'])};
        }

        svg {
            fill: ${darken(0.2, COLORS['blue-60'])};
        }
    }
`;

export const HeaderButtons = styled(FLEX_VERTICAL_CENTER_DIV)`
    margin-left: auto;
`;

export const HeaderButton = styled('span', { disabled: Boolean })`
    display: inline-flex;
    align-items: center;
    color: ${COLORS['blue-60']};
    cursor: pointer;
    svg {
        ${square(16)}
    }
    svg,
    path {
        fill: ${COLORS['blue-60']};
    }
    a {
        margin-left: 8px;
        font-size: 13px;
        font-weight: 500;
    }

    ${({ disabled }) =>
        disabled &&
        css`
            color: ${COLORS['gray-40']};
            cursor: not-allowed;
            &:hover {
                color: ${COLORS['gray-40']};
            }
        `}
`;

export const HeaderButtonText = styled.span`
    margin-left: 8px;
    font-size: 13px;
    font-weight: 500;
`;

export const Diveder = styled.span`
    width: 1px;
    height: 12px;
    margin: 0 12px;
    background-color: #d8d8d8;
`;

export const ButtonsWrapper = styled(FLEX_DIV, { noBorder: Boolean })`
    justify-content: space-between;
    padding-top: 24px;
    border-top: 1px solid
        ${R.ifElse(
            R.propEq('noBorder', true),
            R.always(COLORS['white']),
            R.always(COLORS['gray-15'])
        )};
    width: 100%;
    &:last-child {
        padding-bottom: 24px;
    }
`;

export const Button = styled.button`
    height: 44px;
    width: 100%;
    border-radius: 2px;
    border: solid 1px ${COLORS['gray-30']};
    font-size: 14px;
    font-weight: 600;
    color: ${COLORS['gray-80']};
`;

export const ItemWrapper = styled.div`
    width: 100%;
`;

export const ItemContainer = styled(FLEX_DIV)`
    align-items: flex-start;
    padding-top: 20px;
    font-size: 14px;

    &:last-child {
        padding-bottom: 20px;
    }
`;

export const Label = styled.label`
    display: inline-flex;
    align-items: center;
    color: ${COLORS['gray-50']};
    width: 120px;
    height: 44px;
    white-space: pre-line;
    font-weight: normal;
`;

export const ValueWrapper = styled.span`
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    width: calc(100% - 125px);
    height: fit-content;
    word-break: break-word;
    padding: 15px;
    min-height: 44px;
    background-color: ${COLORS['gray-10']};
    color: ${COLORS['gray-60']};
    font-weight: normal;
    border-radius: 2px;
`;
